import { useMemo } from 'react'
import { IssuesModule } from '@/core/modules/issues'
import {
    assetNameColumn,
    loginUrlsColumn,
} from '@ui/drawer/common/AffectedAssetsTable'
import {
    TSelectableAsset,
    getSelectableAssets,
} from '@ui/drawer/common/useIssueResolution'
import { useIssueDrawer } from '@ui/drawer/common/useIssueDrawer'

export const useUserLeakedCredIssueDetails = () => {
    const { issue, rows, selectedIds, setSelectedIds, resolution } =
        useIssueDrawer<TUserLeakedCredIssue, TSelectableAsset>({
            store: IssuesModule,
            buildRows: getSelectableAssets,
        })

    const columns = useMemo(() => [assetNameColumn(), loginUrlsColumn()], [])

    const selectedPayloads = useMemo(
        () =>
            rows
                .filter(({ id }) => selectedIds.includes(id))
                .map(({ payload }) => payload),
        [rows, selectedIds]
    )

    const selectionDisabled = issue.status !== 'open' || resolution.loading

    return {
        issue,
        rows,
        columns,
        selectedIds,
        setSelectedIds,
        resolution,
        selectedPayloads,
        selectionDisabled,
    }
}
